import { round } from "@/3d/math";
import { InputNumber } from "@/dom/components/Input/Input";
import { Row } from "@/dom/components/Panel/Row";
import { Section } from "@/dom/components/Panel/Section";
import { useDemoState } from "@/state/demoState";
import { getWallSizePropForWallKey, WallKey } from "@/state/RoomConfig/RoomConfig";
import { useRoomSizeRestrictions } from "@/utils/useRoomSizeRestrictions";

import React from "react";

type WallSizeSectionProps = {
    wallKey: WallKey;
};

export const WallSizeSection: React.FC<WallSizeSectionProps> = ({ wallKey }) => {
    const roomConfig = useDemoState((state) => state.roomConfig);
    const setRoomConfig = useDemoState((state) => state.setRoomConfig);

    const roomRestrictions = useRoomSizeRestrictions();

    const isSideWall = wallKey === "leftWall" || wallKey === "rightWall";
    const sizeProp = getWallSizePropForWallKey(wallKey);
    const size = roomConfig[sizeProp];

    const handleSizeChange = (value: number) => {
        const prop = isSideWall ? "depth" : "width";
        let processedValue = value / 1000;

        if (processedValue < roomRestrictions.min[prop]) {
            processedValue = roomRestrictions.min[prop];
        } else if (processedValue > roomRestrictions.max[prop]) {
            processedValue = roomRestrictions.max[prop];
        }

        setRoomConfig({ ...roomConfig, [prop]: round(processedValue, 2) });
    };

    return (
        <Section title="Размеры">
            <Row>
                <span>Длина (мм)</span>
                <InputNumber width="small" value={size * 1000} onBlur={handleSizeChange} />
            </Row>
        </Section>
    );
};
